import {
  FieldsState,
  FieldUIState,
  TemplateType,
} from '../../../../store/types/template';
import { FIELD_CONFIG, SLOT_ORDER } from './fieldVisibilityConfig';

const PRIMARY_FIELD_CAP = 3;

export interface PosterFace {
  header: FieldUIState[];
  primary: FieldUIState[];
  back: FieldUIState[];
}

export interface PosterFieldMapping {
  face: PosterFace;
  additionalInfoFields: FieldUIState[];
}

export interface PosterFieldMappingInput {
  templateType: TemplateType;
  fields: FieldsState;
}

const isFieldPresent = (
  field: FieldUIState | null | undefined
): field is FieldUIState =>
  Boolean(field && (field.id || field.label || field.defaultValue));

const presentSlots = (
  section: Record<string, FieldUIState | null> | undefined
): FieldUIState[] =>
  SLOT_ORDER.map((slot) => section?.[slot]).filter(isFieldPresent);

export function mapFieldsForPoster({
  templateType,
  fields,
}: PosterFieldMappingInput): PosterFieldMapping {
  const config = FIELD_CONFIG[templateType];

  const headerFields = presentSlots(fields?.header);
  const headerCap = config.header.limit;
  const headerOverflow = headerFields.slice(headerCap);

  const candidates = [
    ...presentSlots(fields?.central),
    ...presentSlots(fields?.details),
  ];
  const candidateOverflow = candidates.slice(PRIMARY_FIELD_CAP);

  return {
    face: {
      header: headerFields.slice(0, headerCap),
      primary: candidates.slice(0, PRIMARY_FIELD_CAP),
      back: presentSlots(fields?.back),
    },
    additionalInfoFields: [...headerOverflow, ...candidateOverflow],
  };
}
